// extracted by mini-css-extract-plugin
module.exports = {"label":"SelectFilter_label__3qiUc"};